import React from "react";
import { Button, Modal } from "antd";
import { BookOutlined, WarningOutlined } from "@ant-design/icons";
import { useLocation } from "react-router";
import { getDataLogin } from "../utils/getDataLogin";


UserManualButton.propTypes = {

};

export default function UserManualButton() {
  const [pdfPath, setPdfPath] = React.useState("");
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const location = useLocation();
  const locationPathname = location.pathname;
  const currentMainPath = locationPathname.split("/")[1];

  const currentUser = getDataLogin();
  const currentUserPrivilege = currentUser?.privilege?.name ?? "";

  const handleUserManualButton = () => {
    try {
      if (currentUserPrivilege === "Client") {
        setPdfPath(`/manual/client/${currentMainPath}/${currentMainPath}.pdf`);
      } else {
        setPdfPath(`/manual/lbf/${currentMainPath}/${currentMainPath}.pdf`);
      }

      setIsModalOpen(true);
    } catch (err) {
      console.error("User manual not found", err);
      setPdfPath("");
      setIsModalOpen(true);
    }
  };

  return (
    <>
      <Button
        type="primary"
        icon={<BookOutlined />}
        style={{ width: "fit-content" }}
        onClick={handleUserManualButton}
      >
        User Manual
      </Button>

      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={"50%"}
      >
        {pdfPath ? (
          <iframe
            title="User Manual"
            src={pdfPath}
            width="100%"
            height="600px"
          ></iframe>
        ) : (
          <div
            style={{
              textAlign: "center",
              alignContent: "center",
              height: "300px",
            }}
          >
            <p
              style={{
                fontSize: "50px",
                fontWeight: "bold",
                margin: 0,
              }}
            >
              <WarningOutlined /> User manual not found!
            </p>
            <p style={{ fontSize: "20px", margin: 0 }}>
              Please contact your administrator
            </p>
          </div>
        )}
      </Modal>
    </>
  );
}
